// Material Dashboard 2 PRO React TS Base Styles
import colors from '@theme/base/colors';

// Material Dashboard 2 PRO React TS Helper Functions
import pxToRem from '@theme/functions/pxToRem';

const { transparent, secondary } = colors;

// types
type Types = any;

const select: Types = {
  styleOverrides: {
    root: {
      '&.MuiInputBase-colorInfo': {
        '& .MuiSelect-select': {
          fontSize: '0.875rem'
        }
      },
      '& .MuiOutlinedInput-input': {
        color: secondary.main
      },
      '& .MuiOutlinedInput-notchedOutline, &.Mui-focused .MuiOutlinedInput-notchedOutline':
        {
          borderColor: secondary.main,
          '&:after': {
            borderColor: secondary.main
          }
        }
    },
    select: {
      display: 'grid',
      alignItems: 'center',
      padding: `0 ${pxToRem(12)} !important`,
      // '& span': {
      //   textTransform: 'uppercase'
      // },
      '& .Mui-selected': {
        backgroundColor: transparent.main
      }
    },
    icon: {
      color: secondary.main
    },
    selectMenu: {
      background: 'none',
      height: 'none',
      minHeight: 'none',
      overflow: 'unset',
      color: secondary.main
    }
  }
};

export default select;
